export default __webpack_public_path__ + "static/media/profile-picture.5c1644ea.jpeg";